import React from "react"

/**
 * this component provides a congruent display of statistic-information for the marketplace
 */

interface IProps {
  count: number
  label: string
  className?: string
}

const MarketStatsDisplay: React.FC<IProps> = ({ count, label, className }: IProps) => {
  const finalClassName = ["stats-view", className || ''].join(' ').trim()

  return <div className={finalClassName}>
    <span className="stats-view--count">{count}</span>
    <span className="ml-2">{label}</span>
  </div>
}

export default MarketStatsDisplay
